<template>
    <div class="image-container">
        <div class="flip-card" :class="{ 'is-flipped': isRevealed }">
            <!-- 正面（盖住状态） -->
            <div class="flip-card-front">
                <img src="../images/cover.png" class="cover-image" />
            </div>
            <!-- 背面（选项图片） -->
            <div class="flip-card-back">
                <el-image
                    ref="image"
                    :src="src" 
                    fit="cover"
                    class="sort-image"
                    :preview-src-list="[src]"
                />
                <img src="../images/check.png" class="check-icon" @click="previewImage" />
            </div>
        </div>
        <button
            v-show="canPickImages && isRevealed"
            class="pick-button" 
            @click.stop="selectImage(index)"
        >
            Pick
        </button>
    </div>
</template>

<script>
import { Image as ElImage } from 'element-ui';
export default {
    components: {
        ElImage
    },
    props: {
        src: {
            type: String,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        canPickImages: {
            type: Boolean,
            default: false,
        },
        isRevealed: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        selectImage(index) {
            this.$emit('select-image', index);
        },
        previewImage() {
            const parent = this.$refs.image.$el
            const img = parent?.querySelector('img')
            img?.click()
        }
    }
}
</script>

<style scoped>
.image-container {
    position: relative;
    width: 24%;
    height: 240px;
    background: #fff;
    border-radius: 28px;
    box-shadow: 0px 3px 8px rgba(227, 30, 30, 0.25);
    margin-bottom: 20px;
    margin-left: 1%;
    cursor: pointer;
}

/* 翻转卡片容器 */
.flip-card {
    position: relative;
    width: 100%;
    height: 100%;
    perspective: 1000px;
}

.flip-card-front,
.flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    transition: transform 0.6s ease;
    border-radius: 12px;
    overflow: hidden;
}

/* 正面（盖住状态） */
.flip-card-front {
    box-sizing: border-box;
    transform: rotateY(0deg);
    z-index: 2;
    border-radius: 12px;
    overflow: hidden;
}

.cover-image {
    width: 100%;
    height: 100%;
}

/* 背面（选项图片） */
.flip-card-back {
    transform: rotateY(180deg);
    z-index: 1;
    height: 180px;
}

/* 翻转状态 */
.flip-card.is-flipped .flip-card-front {
    transform: rotateY(-180deg);
}

.flip-card.is-flipped .flip-card-back {
    transform: rotateY(0deg);
}

.sort-image {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 8px;
  object-fit: cover;
}
.sort-image::v-deep img {
  border-radius: 16px;
}

.check-icon {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 1);
  border-bottom-left-radius: 16px;
  border-top-right-radius: 16px;
}

.pick-button {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    border-radius: 20px;
    background: rgba(141, 201, 89, 1);
    box-shadow:inset 0px -1.21px 3.03px  rgba(42, 135, 47, 0.57), 0px 0.61px 2.43px  rgba(0, 0, 0, 0.45);
    padding: 8px 40px;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
    transition: background-color 0.2s;
}

.pick-button:hover {
    background-color: #7cb342;
}

.pick-button:disabled {
    box-shadow: none;
    background-color: #cccccc;
    cursor: not-allowed;
}
</style>